import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialogActions,
  MatDialogContent,
  MatDialogRef,
  MatDialogTitle,
} from '@angular/material/dialog';
import { MatButton } from '@angular/material/button';
import { provideI18nScope } from '@pct-ng/transloco';
import { ResolveTranslateAbleTextPipe } from '@pct-ng/i18n';
import type { MessageResult } from '../type/message-result';
import { I18nProviderInjectionToken } from '../i18n/i18n.scope';
import type { DialogMessageOptions } from '../type/message-options';

@Component({
  selector: 'pct-feature-message-material-message-dialog',
  imports: [
    MatDialogContent,
    MatDialogTitle,
    MatButton,
    MatDialogActions,
    ResolveTranslateAbleTextPipe,
  ],
  templateUrl: './message-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [provideI18nScope(I18nProviderInjectionToken)],
})
export class MessageDialogComponent {
  readonly #dialogRef = inject(MatDialogRef<MessageDialogComponent, MessageResult>);
  protected readonly data = inject<DialogMessageOptions>(MAT_DIALOG_DATA);
  protected readonly i18nScope = inject<string>(I18nProviderInjectionToken);

  protected onClickCancel(): void {
    this.#dialogRef.close({
      result: 'CANCEL',
    });
  }

  protected onClickSubmit(): void {
    this.#dialogRef.close({
      result: 'SUBMIT',
    });
  }
}
